import { SVGProps } from "react";

export function SuccessIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <path
        fill="#CEE9DE"
        d="M41.803 2.364a3 3 0 0 1 4.395 0l6.406 6.893a3 3 0 0 0 2.942.864l9.115-2.335a3 3 0 0 1 3.698 2.376l1.662 9.262a3 3 0 0 0 2.008 2.317l8.931 2.964a3 3 0 0 1 1.826 3.998l-3.609 8.69a3 3 0 0 0 .437 3.035l5.91 7.322a3 3 0 0 1-.625 4.35l-7.734 5.36a3 3 0 0 0-1.274 2.79l1.014 9.355a3 3 0 0 1-2.878 3.321l-9.404.328a3 3 0 0 0-2.58 1.658L57.84 83.33a3 3 0 0 1-4.217 1.238l-8.089-4.809a3 3 0 0 0-3.066 0l-8.089 4.81a3 3 0 0 1-4.217-1.239l-4.204-8.418a3 3 0 0 0-2.58-1.658l-9.404-.328a3 3 0 0 1-2.878-3.321l1.014-9.356a3 3 0 0 0-1.274-2.788L3.101 52.1a3 3 0 0 1-.626-4.35l5.911-7.323a3 3 0 0 0 .437-3.035l-3.609-8.69a3 3 0 0 1 1.826-3.998l8.93-2.964a3 3 0 0 0 2.009-2.317l1.663-9.262a3 3 0 0 1 3.697-2.376l9.115 2.335a3 3 0 0 0 2.942-.864l6.407-6.893Z"
      />
      <path
        fill="#1F9E80"
        d="m38.667 47.533 15.866-15.866c.667-.623 1.4-.934 2.2-.934.8 0 1.534.311 2.2.934.667.666 1 1.41 1 2.233 0 .822-.333 1.567-1 2.233l-18 18.067a3.086 3.086 0 0 1-2.266.933A3.086 3.086 0 0 1 36.4 54.2L29 46.8c-.622-.667-.933-1.411-.933-2.233 0-.822.333-1.567 1-2.234.666-.622 1.41-.933 2.233-.933.822 0 1.567.311 2.233.933l5.134 5.2Z"
      />
    </svg>
  );
}
